<template>
  <div v-if="getUserByUserId.role !== 'employee'">
    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleClick"
      v-if="channel.type === 'private'"
      >Join ₹ {{ this.channel.price }}</base-button
    >
    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleClick"
      v-else-if="channel.type === 'public'"
      >Join</base-button
    >
  </div>
  <div
    v-else-if="
      getUserByUserId.currentMembership.name === 'Corporate Premium' &&
      getUserByUserId.role === 'employee'
    "
  >
    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleEmpJoin"
      >Join</base-button
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    channel: {
      type: Object,
      default: () => {},
    },
    data() {
      return {
        Price: "",
      };
    },
  },
  computed: {
    ...mapState("auth", {
      user: "user",
      getUserByUserId: "getUserByUserId",
    }),
  },
  methods: {
    handleClick() {
      if (this.channel.type === "private") {
        this.handlePrivateJoin();
      } else if (this.channel.type === "public") {
        this.handlePublicJoin();
      }
    },

    joinAlert() {
      return this.$swal({
        text: `Would you like to become a member of ${this.channel.name}?`,
        icon: "question",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
      });
    },

    async handlePrivateJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        this.$swal.fire({
          text: `Your payment done succesfully`,
          icon: "success",
          confirmButtonText: "Ok",
          showCancelButton: false,
          cancelButtonColor: "#60d394",
        });
        this.$store.dispatch("channel/joinChannel", {
          channelID: this.channel._id,
        });
      }
    },

    async handlePublicJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        const payload = {
          channelID: this.channel._id,
          UserID: [this.user._id],
        };
        let loader = this.$loading();
        try {
          await this.$store.dispatch("channel/addMember", payload);
          this.$store.commit("channel/ADD_MEMBER", payload);
          loader.close();
        } catch (error) {
          if (error) {
            loader.close();
          }
        }
      }
    },

    async handleEmpJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        const payload = {
          channelID: this.channel._id,
          UserID: [this.user._id],
        };
        let loader = this.$loading();
        try {
          await this.$store.dispatch("channel/empChannelJoin", payload);
          this.$store.commit("channel/ADD_MEMBER", payload);
          loader.close();
        } catch (error) {
          console.log(error);
          if (error) {
            loader.close();
          }
        }
      }
    },
  },
  async mounted() {
    // await this.$store.dispatch("auth/getUserByUserId", {
    //   userId: this.user._id,
    // });
    // console.log(this.getUserByUserId);
  },
};
</script>
